import { Card, Tabs, Table, Row, Col, Tag, Form, Input, DatePicker, Button, Avatar, Menu, Upload, Dropdown, Modal, Skeleton, Select, Image, Space, List } from "antd";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import React, { useEffect, useState, useCallback, useRef } from "react";
import { HexColorPicker } from "react-colorful";
import { Redirect } from "react-router-dom";
// import Clock from 'react-live-clock';
import {
    SearchOutlined, FilePdfOutlined, WifiOutlined, CloseCircleOutlined, DesktopOutlined, PlusOutlined, FontColorsOutlined, ContactsOutlined, PlusSquareOutlined, UserOutlined, PhoneFilled, MailFilled, FileExcelOutlined, DeleteOutlined, TeamOutlined, FormOutlined, SkinOutlined, CheckOutlined
} from "@ant-design/icons";
import swal from "sweetalert";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { useDispatch, useSelector } from "react-redux";
import { formatLongDate } from "../common/Format";
import moment from 'moment';
import 'moment/locale/vi';
import locale from 'antd/es/date-picker/locale/vi_VN';

import axiosClient from "../../api/axios";
import ButtonGroup from "antd/lib/button/button-group";
import LinkUpload from "../../api/LinkUpload";

const { TabPane } = Tabs;
const { Option } = Select;
const Customer = () => {
    const [dataLocationAll, setDataLocationAll] = useState([]);
    const [dataCompany, setDataCompany] = useState([]);
    const idCompany = Number(localStorage.getItem('IDCompany'))



    const { isLoggedIn } = useSelector((state) => state.auth);
    const refSearch = useRef();
    // ----------------------------------------
    const title = localStorage.getItem('Title');
    const fullname = localStorage.getItem('FullName');

    // upload image
    const [dataHeader, setDataHeader] = useState([]);


    // Xuất Excell
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToCSV = async (csvData, fileName) => {
        if (csvData.length === 0) {
            swal('Không có dữ liệu nên không thể xuất Excel', {
                icon: 'error',
                button: false,
                timer: 2000
            })
        }
        else {
            const ws = XLSX.utils.json_to_sheet(csvData);
            var wscols = [
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 10 },
                { wch: 20 },
                { wch: 10 },
                { wch: 20 },
                { wch: 30 },
            ];

            ws['!cols'] = wscols;
            // let header = ["ID", "Tên khách hàng", "Số điện thoại", "Email", "Giới tính", "Thời gian truy cập", "Vị trí", "Hệ điều hành", "Địa chỉ MAC"]
            const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            const option = {
                suggestedName: fileName + fileExtension,
                types: [
                    {
                        description: 'xlsx',
                        accept: {
                            'text/plain': ['.xlsx'],
                        },
                    },
                ],
            };
            const handle = await window.showSaveFilePicker(option);
            const writer = await handle.createWritable();
            writer.write(data);
            writer.close();
            // FileSaver.saveAs(data, fileName + fileExtension);
        }

    }



    const token = localStorage.getItem('token');
    const header = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };


    const [formCustomer] = Form.useForm();



    const [dataCustommer, setDataCustommer] = useState([]);

    const calculate_age = (dob1) => {
        var today = new Date();
        var birthDate = new Date(dob1);  // create a date object directly from `dob1` argument
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age_now--;
        }
        console.log(age_now);
        return age_now;
    }
    const columnsCustommer = [
        {
            title: <div style={{ textAlign: 'center', fontSize: 12 }}>Khách hàng</div>,
            dataIndex: 'CustomerName',
            width: 170,
            sorter: (a, b) => a.FullName.length - b.FullName.length,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: 'left', fontSize: 12 }}>
                        <Row>
                            <Col span={24}>
                                Tên : <b>{record.FullName}</b>
                            </Col>
                            <Col span={24}>
                                Ngày tham gia : {moment(record.ParticipationDate).format('DD-MM-YYYY')}
                            </Col>
                        </Row>

                    </div>
                )
            }
        },
        {
            title: <div style={{ textAlign: 'center', fontSize: 12 }}>CCCD/Hộ chiếu</div>,
            dataIndex: 'PhoneNumber',
            width: 130,
            sorter: (a, b) => a.IDCard - b.IDCard,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: 'center', fontSize: 12 }}>
                        {record.IDCard}
                    </div>
                )
            }
        },
        {
            title: <div style={{ textAlign: 'center', fontSize: 12 }}>Số điện thoại</div>,
            dataIndex: 'PhoneNumber',
            width: 130,
            sorter: (a, b) => a.Phone - b.Phone,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: 'center', fontSize: 12 }}>
                        {record.Phone}
                    </div>
                )
            }
        },
        {
            title: <div style={{ textAlign: 'center', fontSize: 12 }}>Email</div>,
            dataIndex: 'Email',
            sorter: (a, b) => a.Email.localeCompare(b.Email),
            width: 150,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: 'left', fontSize: 12 }}>
                        {record.Email}
                    </div>
                )
            }
        },
        {
            title: <div style={{ textAlign: 'center', fontSize: 12 }}>Địa chỉ</div>,
            dataIndex: 'Sex',
            width: 150,
            sorter: (a, b) => a.Address.length - b.Address.length,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: 'center', fontSize: 12 }}>
                        {record.Address} - {record.City}
                    </div>
                )
            }
        },
        {
            title: <div style={{ textAlign: 'center', fontSize: 12 }}>Ngày sinh</div>,
            dataIndex: 'Sex',
            width: 120,
            sorter: (a, b) => a.BirthDay.localeCompare(b.BirthDay),
            render: (text, record) => {
                return (
                    <div style={{ textAlign: 'center', fontSize: 12 }}>
                        <Row>
                            <Col span={24}>
                                {moment(record.BirthDay).format('DD-MM-YYYY')}
                            </Col>
                            <Col span={24}>
                                {calculate_age(moment(record.BirthDay).format('YYYY-MM-DD'))} Tuổi
                            </Col>
                        </Row>

                    </div>
                )
            }
        },
        {
            title: <div style={{ textAlign: 'center', fontSize: 12 }}>Quốc tịch</div>,
            dataIndex: 'AccessLocationID',
            width: 150,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: 'center', fontSize: 12 }}>
                        <Row>

                            <Col span={24}>
                                {record.Nationality}
                            </Col>
                        </Row>

                    </div>
                )
            }
        },
        {
            title: <div style={{ textAlign: 'center', fontSize: 12 }}>Người bảo hộ</div>,
            dataIndex: 'AccessLocationID',
            width: 150,
            sorter: (a, b) => a.IDLocation - b.IDLocation,
            render: (text, record) => {

                return (
                    <div style={{ textAlign: 'left', fontSize: 12 }}>
                        <Row>
                            <Col span={24}>
                                Tên : <b>{record.EmergencyContactName}</b>
                            </Col>
                            <Col span={24}>
                                SĐT : <b>{record.EmergencyContactPhone}</b>
                            </Col>
                          
                        </Row>

                    </div>
                )
            }
        },
        {
            title: <div style={{ textAlign: 'center', fontSize: 12 }}>Bảng đăng ký</div>,
            dataIndex: 'OS',
            width: 90,

            render: (text, record) => {
                return (
                    <div style={{ textAlign: 'center' }}>
                        <FilePdfOutlined style={{ fontSize: 50, color: 'red' }} onClick={(e) => window.open(LinkUpload(record.FormPath), '_blank')} />
                    </div>
                )
            }
        },



    ];
    const loadCustomer = (values) => {

        axiosClient.post('Customers/FilterCustomers', values, { headers: header }).then(res => {

            if (res.status === 200) {
                setDataCustommer(res.data);
                const customHeadings = res.data.map(item => ({
                    "Tên khách hàng": item.CustomerName,
                    "Số điện thoại": item.PhoneNumber,
                    "Email": item.Email,
                    "Giới tính": item.Sex,
                    "Thời gian truy cập": item.AccessDateTime,
                    "Vị trí": item.AccessLocationID,
                    "Hệ điều hành": item.OS,
                    "Địa chỉ MAC": item.MAC
                }))
                setDataHeader(customHeadings)

            }

        })
    }


    const role = localStorage.getItem('Role');

    const LoadDataCompany = (values) => {
        axiosClient.post('/Company/FilterCompany', {
            "ID": 1,
            "CompanyName": "",
            "Phone": "",
            "Address": "",
            "Logo": "",
            "Note": ""
        }, { headers: header }).then(res => {
            setDataCompany(res.data)

        })
    }

    const [dataLocation, setDataLocation] = useState([])
    const LoadDataLocation = (values) => {
        axiosClient.post('/Location/FilterLocation', values, { headers: header }).then(res => {
            setDataLocation(res.data)
            if (idCompany !== 0) {
                setDataLocationAll(res.data.filter(i => i.IDCompany === idCompany))
            }
        })
    }

    const [dataFilterLocation, setDataFilterLocation] = useState({
        "IDCompany": 0,
        "CompanyName": "",
        "FromDate": "",
        "ToDate": ""
    })

    const [dataFilterCustomer, setDataFilterCustomer] = useState({
        "FullName": "",
        "IDCard": "",
        "Phone": "",
        "Email": "",
        "Nationality": "",
        "EmergencyContactName": "",
        "EmergencyContactPhone": "",
        "IDGuardian": 0,
        "FromDate": moment().startOf('month'),
        "ToDate": moment()
    })


    useEffect(() => {

        formCustomer.setFieldsValue({
            "FromDate": moment().startOf('month'),
            "ToDate": moment()
        })
        loadCustomer(dataFilterCustomer);

    }, [])
    const SearchCustomer = (values) => {
        const filter = {

            "FullName": values.FullName === undefined || values.FullName === null ? '' : values.FullName,
            "IDCard": values.IDCard === undefined || values.IDCard === null ? '' : values.IDCard,
            "Phone": values.Phone === undefined || values.Phone === null ? '' : values.Phone,
            "Email": values.Email === undefined || values.Email === null ? '' : values.Email,
            "Nationality": values.Nationality === undefined || values.Nationality === null ? '' : values.Nationality,
            "EmergencyContactName": values.EmergencyContactName === undefined || values.EmergencyContactName === null ? '' : values.EmergencyContactName,
            "EmergencyContactPhone":values.EmergencyContactPhone === undefined || values.EmergencyContactPhone === null ? '' : values.EmergencyContactPhone,
            "IDGuardian": values.IDGuardian === undefined || values.IDGuardian === null ? 0 : values.IDGuardian,
            "FromDate": values.FromDate === undefined || values.FromDate === null ? '' : moment(values.FromDate).format('YYYY-MM-DD HH:mm:ss'),
            "ToDate": values.ToDate === undefined || values.ToDate === null ? '' : moment(values.ToDate).format('YYYY-MM-DD HH:mm:ss')
        }
        setDataFilterCustomer(filter)
        loadCustomer(filter)
    }


    var resultCustomer = [];

    let isExist = (arr, x) => {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] === x) return true;
        }
        return false;
    };
    const onFooterCustomer = (record) => {
        var arrayid = record.map((i) => i.ID);
        arrayid.forEach((element) => {
            if (!isExist(resultCustomer, element)) resultCustomer.push(element);
        });
        return <div>
            <p style={{ textAlign: 'center' }}>Đã xem {resultCustomer.length} / {dataCustommer.length} Khách hàng</p>
        </div>
    }
    const selectCompany = (value) => {
        formCustomer.setFieldsValue({
            IDLocation: 0
        })
        setDataLocationAll(dataLocation.filter(i => i.IDCompany === Number(value)))
    }

    return (
        <div style={{ backgroundColor: '#F0F2F5' }}>
            <Card size="small" bodyStyle={{ backgroundColor: '#F0F2F5' }}  >
                <Tabs type="card" defaultActiveKey="1" >
                    <TabPane tab="Thông tin khách hàng" key="1">
                        <Row>
                            <Col span={24}>
                                <Form ref={refSearch} id="form-filter" form={formCustomer} onFinish={SearchCustomer}>
                                    <Row gutter={16}>

                                        <Col xs={24} xl={6} span={4}>
                                            <Form.Item label='Tên KH' name="FullName">
                                                <Input style={{ borderRadius: 5 }} placeholder="Tên khách hàng" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={6} span={4}>
                                            <Form.Item label='SĐT' name="Phone">
                                                <Input style={{ borderRadius: 5 }} placeholder="Số điện thoại" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={6} span={4}>
                                            <Form.Item label='IDCard' name="IDCard">
                                                <Input style={{ borderRadius: 5 }} placeholder="IDCard" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={6} span={4}>
                                            <Form.Item label='Quốc gia' name="Nationality">
                                                <Input style={{ borderRadius: 5 }} placeholder="Nationality" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={6} span={4}>
                                            <Form.Item label='Tên người bảo hộ' name="EmergencyContactName">
                                                <Input style={{ borderRadius: 5 }} placeholder="Nationality" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={6} span={4}>
                                            <Form.Item label='Số ĐT người bảo hộ' name="EmergencyContactPhone">
                                                <Input style={{ borderRadius: 5 }} placeholder="Nationality" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={6} span={4}>
                                            <Form.Item label='Từ ngày' name="FromDate">
                                                <DatePicker format={'DD-MM-YYYY'} disabledDate={(current) => {
                                                    let customDate = moment();
                                                    //let limitDate = moment('2022-12-01').format('DD-MM-YYYY');
                                                    return current > moment(customDate, 'DD-MM-YYYY');
                                                }} locale={locale} style={{ width: '100%', borderRadius: 5 }} placeholder="Từ ngày" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={6} span={4}>
                                            <Form.Item label='Đến ngày' name="ToDate">
                                                <DatePicker format={'DD-MM-YYYY'} disabledDate={(current) => {
                                                    let customDate = moment();
                                                    //let limitDate = moment('2022-12-01').format('DD-MM-YYYY');
                                                    return current > moment(customDate, 'DD-MM-YYYY');
                                                }} locale={locale} style={{ width: '100%', borderRadius: 5 }} placeholder="Đến ngày" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={10} xl={24} span={10}>
                                            <ButtonGroup>
                                                <Button style={{ backgroundColor: '#1874CD', color: 'white', borderRadius: 5, minWidth: 100, fontWeight: 'bolder' }} icon={<SearchOutlined />} form='form-filter' type="primary" htmlType="submit">
                                                    Lọc
                                                </Button>
                                                {/* &ensp;
                                                <Button style={{ backgroundColor: '#00CC99', color: 'white', borderRadius: 5 }} onClick={(e) => exportToCSV(dataHeader, `DuLieuKhachHang-${moment().format("DD/MM/YYYY HH:mm")}`)} icon={<FileExcelOutlined />}>Xuất excel</Button> */}

                                            </ButtonGroup>


                                        </Col>

                                    </Row>
                                </Form>
                            </Col>

                            <Col style={{ marginTop: 23 }} span={24}>
                                {/* expandedRowRender={(record, i) => <p>{i}</p>} thẻ con */}
                                <Table rowClassName={(record, index) => {
                                    return index % 2 === 0 ? "gray-color" : "";
                                }} footer={(record) => onFooterCustomer(record)} bordered size="middle" scroll={{ x: 1000 }} pagination={{ pageSize: 10 }} sticky dataSource={dataCustommer} columns={columnsCustommer} />
                            </Col>
                        </Row>
                    </TabPane>

                </Tabs>
            </Card>

        </div>
    )
}
export default Customer;